import { HEADER_TYPE } from '../../UnifiedNavigation/types';
export function shouldShowBalance({ type, state, }) {
    return type === HEADER_TYPE.Private && state === 'ACTIVE';
}
//# sourceMappingURL=shouldShowBalance.js.map